export default __webpack_public_path__ + "static/media/Today.d1f85eb2.svg";